import React from 'react';
import { ThemedText } from '../../../components';
import { parseImageList } from '../parsers';

export default function SingleImageValue({ value, field, attachments, emptyValue = '—', theme, onImageClick }) {
  const fieldKey = field?.id || field?.key;
  const fieldAttachment = attachments?.find(
    a => a.fieldName === fieldKey && (a.type === 'Image' || a.type === 'Drawing')
  );

  const url = fieldAttachment?.url || parseImageList(value)[0];

  if (!url) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }

  const handleClick = onImageClick
    ? (e) => { e.preventDefault(); onImageClick(fieldAttachment || { url, fileUrl: url, fileName: field?.props?.label || 'Image' }); }
    : undefined;

  return (
    <a
      href={url}
      target={onImageClick ? undefined : '_blank'}
      rel={onImageClick ? undefined : 'noopener noreferrer'}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <img
        src={url}
        alt={fieldAttachment?.fileName || field?.props?.label || 'Image'}
        style={{
          maxWidth: 200,
          maxHeight: 200,
          objectFit: 'contain',
          borderRadius: theme?.borderRadius?.sm || 4,
          border: `1px solid ${theme?.colors?.border || '#e0e0e0'}`,
        }}
      />
    </a>
  );
}
